import {
  rbcHtsAssistApi,
  type PrewarmRequest,
} from "@b2bportal/rbc-hts-assist-api";
import { axiosInstance } from "@hopper-b2b/api";

export type PrewarmHtsAssistRequest = PrewarmRequest;

export const prewarmHtsAssist = async (
  request: PrewarmHtsAssistRequest
): Promise<void> => {
  await rbcHtsAssistApi(axiosInstance).apiV0HtsAssistPrewarmPost(request);
};
